import {
  BriefcaseBusiness,
  Database,
  FileText,
  SquareMenu,
  Landmark,
  MonitorCog,
  ReceiptText,
  SquarePercent,
  TicketSlash,
  Users,
  UserIcon,
  UserCircle,
} from "lucide-react";

import Home from "Pages/Home";
import ManageGST from "Pages/AdminMaster/ManageGST/ManageGST";
import ApplyFor from "Pages/AdminMaster/Flight/ApplyFor/ApplyFor";
import FlightMarkupType from "Pages/AdminMaster/Flight/MarupType/FlightMarkupType";
import FareType from "Pages/AdminMaster/Flight/FareType/FareType";
import ApplyOn from "Pages/AdminMaster/Flight/ApplyOn/ApplyOn";
import MarkupFee from "Pages/AdminMaster/Flight/MarkupFee/MarkupFee";
import Airlines from "Pages/AdminMaster/Flight/Airlines/Airlines";
import Suppliers from "Pages/AdminMaster/Flight/Suppliers/Suppliers";
import OriginCountry from "Pages/AdminMaster/Flight/OriginCountry/OriginCountry";
import SearchType from "Pages/AdminMaster/Flight/SearchType/SearchType";
import ApplyType from "Pages/AdminMaster/Flight/ApplyType/ApplyType";
import HotelSuppliers from "Pages/AdminMaster/Hotels/Suppliers/HotelSuppliers";
import HotelCategory from "Pages/AdminMaster/Hotels/Suppliers copy/HotelCategory";
import CreateMarkup_B2C from "Pages/AdminTransactions/CreateMarkup-B2C/CreateMarkup_B2C";
import CreateDiscount_B2C from "Pages/AdminTransactions/CreateDiscount-B2C/CreateDiscount-B2C";
import ManageGroupB2B from "Pages/GroupSettings/ManageGroup-B2B/ManageGroup-B2B";
import ViewMarkupB2B from "Pages/GroupSettings/ViewMarkup-B2B/ViewMarkup-B2B";
import ManageChargeTypes from "Pages/TaxesAndCharges/ManageChargeTypes/ManageChargeTypes";
import ManageSubChargeTypes from "Pages/TaxesAndCharges/ManageSubChargeTypes/ManageSubChargeTypes";
import MyCharges from "Pages/TaxesAndCharges/MyCharges/MyCharges";
import OtherCharges from "Pages/TaxesAndCharges/OtherCharges/OtherCharges";
import Affiliates from "Pages/Affiliates/Affiliates";
import OnlineFlightBookingList from "Pages/Booking/OnlineBooking/OnlineFlightBookingList";
import OnlineHotelsBooking from "Pages/Booking/OnlineBooking/OnlineHotelsBooking";
import FlightBookingDetails1G from "Pages/Booking/OnlineBooking/Components/FlightBookingDetails1G";
import FlightBookingDetailsNavitaire from "Pages/Booking/OnlineBooking/Components/FlightBookingDetailsNavitaire";
import ManageAffiliates from "Pages/Affiliates/ManageAffiliates";
import HotelBookingDetailsHB from "Pages/Booking/OnlineBooking/Pages/Hotel/HB/HotelBookingDetailsHB";
import RoleManagement from "Pages/UserManagement/RoleManagement";
import UserManagement from "Pages/UserManagement/UserManagement";
import ViewCommissionB2B from "Pages/GroupSettings/ViewCommission-B2B/ViewCommission-B2B";
import BookingList from "Pages/Booking/OnlineBooking/Pages/BookingList";
import PaymentRequest from "Pages/Accounts/Affiliate/PaymentRequest";
import CreateNewPaymentRequest from "Pages/Accounts/Affiliate/NewRequest/CreateNewPaymentRequest";
import CommissionB2B from "Pages/GroupSettings/ManageCommission-B2B/CommissionB2B";
import CreateCommissionB2B from "Pages/GroupSettings/ManageCommission-B2B/CreateCommission-B2B/CreateCommissionB2B";
import AffiliatePaymentRequest from "Pages/Accounts/Admin/AffiliatePaymentRequest/AffiliatePaymentRequest";
import AdminAccount from "Pages/Accounts/Admin/AdminAccounts/AdminAccount";
import AddNewAccount from "Pages/Accounts/Admin/AdminAccounts/NewAccount/AddNewAccount";
import AutoTicketing from "Pages/AutoTicketing/AutoTicketing";
import MarkupB2C from "Pages/AdminTransactions/Markups/MarkupB2C/MarkupB2C";
import ManageMarkupB2C from "Pages/AdminTransactions/Markups/MarkupB2C/ManageMarkupB2C";
import MarkupB2B from "Pages/AdminTransactions/Markups/MarkupB2B/MarkupB2B";
import ManageMarkupB2B from "Pages/AdminTransactions/Markups/MarkupB2B/ManageMarkupB2B";

import { IRoute } from "types";
import BlockAirlines from "Pages/AdminMaster/Flight/Block-Airlines/BlockAirlines";
import Profile from "Pages/Profile/Profile";

export const ROLES = {
  ADMIN: "ADMIN",
  AFFILIATE: "AFFILIATE",
};

export const ROUTES: {
  ALL_ROUTES: IRoute[];
} = {
  ALL_ROUTES: [
    {
      path: "/",
      label: "Home",
      slug: "home",
      element: Home,
      icon: SquareMenu,
      rolesAllowed: [ROLES.ADMIN],
    },

    // {
    //   path: "/user-management",
    //   label: "User Management",
    //   slug: "ROLE_MANAGEMENT",
    //   element: null,
    //   icon: FiSettings,
    //   rolesAllowed: [ROLES.ADMIN],
    //   isSubmenu: true,
    //   submenu: [
    //     {
    //       path: "/user-management/role-management",
    //       label: "Role Management",
    //       slug: "ROLE_MANAGEMENT__ROLE_MANAGEMENT",
    //       element: RoleManagement,
    //       icon: BsTicket,
    //       rolesAllowed: [ROLES.ADMIN],
    //     },
    //     {
    //       path: "/user-management/user-access",
    //       label: "User Access",
    //       slug: "ROLE_MANAGEMENT__USER_MANAGEMENT",
    //       element: UserManagement,
    //       icon: BsTicket,
    //       rolesAllowed: [ROLES.ADMIN],
    //     },
    //   ]
    // },
    {
      path: "/admin-master",
      label: "Admin Master",
      slug: "",
      element: null,
      icon: Database,
      rolesAllowed: [ROLES.ADMIN],
      isSubmenu: true,
      submenu: [
        {
          path: "/admin-master/manage-gst",
          label: "Manage GST",
          slug: "ADMIN_MASTER__MANAGE_GST",
          element: ManageGST,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/apply-for",
          label: "Apply For",
          slug: "ADMIN_MASTER__APPLY_FOR",
          element: ApplyFor,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/markup-type",
          label: "Flight Markup Type",
          slug: "ADMIN_MASTER__FLIGHT_MARKUP_TYPE",
          element: FlightMarkupType,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/fare-type",
          label: "Flight Fare Type",
          slug: "ADMIN_MASTER__FLIGHT_FARE_TYPE",
          element: FareType,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/apply-on",
          label: "Flight Apply On",
          slug: "ADMIN_MASTER__FLIGHT_APPLY_ON",
          element: ApplyOn,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/search-type",
          label: "Flight Search Type",
          slug: "ADMIN_MASTER__FLIGHT_SEARCH_TYPE",
          element: SearchType,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/apply-type",
          label: "FLight Apply Type",
          slug: "ADMIN_MASTER__FLIGHT_APPLY_TYPE",
          element: ApplyType,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/country",
          label: "Flight Country",
          slug: "ADMIN_MASTER__FLIGHT_ORIGIN_COUNTRY",
          element: OriginCountry,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/Suppliers",
          label: "Flight Suppliers",
          slug: "ADMIN_MASTER__FLIGHT_SUPPLIERS",
          element: Suppliers,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/Airlines",
          label: "Flight Airlines",
          slug: "ADMIN_MASTER__FLIGHT_AIRLINES",
          element: Airlines,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/Markup-fee",
          label: "Flight Markup Fee",
          slug: "ADMIN_MASTER__FLIGHT_MARKUP_FEE",
          element: MarkupFee,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/flight/Block-Airlines",
          label: "Flight Block Airlines",
          // slug: "ADMIN_MASTER__FLIGHT_BLOCK_AIRLINES",
          slug: "ADMIN_MASTER__FLIGHT_MARKUP_FEE",
          element: BlockAirlines,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/hotel/supplier",
          label: "Hotel Supplier",
          slug: "ADMIN_MASTER__HOTEL_SUPPLIERS",
          element: HotelSuppliers,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-master/hotel/category",
          label: "Hotel Hotel Category",
          slug: "ADMIN_MASTER__HOTEL_CATEGORY",
          element: HotelCategory,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        // {
        //   path: "/admin-master/bus-supplier",
        //   label: "Bus Supplier",
        //   slug: "ADMIN_MASTER__BUS_SUPPLIERS",
        //   element: BusSuppliers,
        //   icon: BsTruckFront,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        // {
        // {
        //   path: "/admin-master/hold-booking-config",
        //   label: "Hold Booking Config",
        //   slug: "home",
        //   element: HoldBookingConf,
        //   icon: SquareMenu,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        // {
        //   path: "/admin-master/manage-hold-booking",
        //   label: "Manage Hold Booking",
        //   slug: "home",
        //   element: ManageHoldBooking,
        //   icon: SquareMenu,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        // {
        //   path: "/admin-master/enable-coupon-feature",
        //   label: "Enable Coupon Feature",
        //   slug: "home",
        //   element: EnableCouponFeature,
        //   icon: SquareMenu,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
      ],
    },

    // {
    //   path: "/admin-master",
    //   label: "Admin Master",
    //   slug: "",
    //   element: null,
    //   icon: FiSettings,
    //   rolesAllowed: [ROLES.ADMIN],
    //   isSubmenu: true,
    //   submenu: [
    //     {
    //       path: "/admin-master/manage-gst",
    //       label: "Manage GST",
    //       slug: "ADMIN_MASTER__MANAGE_GST",
    //       element: ManageGST,
    //       icon: BsTicket,
    //       rolesAllowed: [ROLES.ADMIN],
    //     },
    //     {
    //       path: "/admin-master/flight",
    //       label: "Flight",
    //       slug: "",
    //       element: null,
    //       icon: MdFlight,
    //       rolesAllowed: [ROLES.ADMIN],
    //       isSubmenu: true,
    //       submenu: [
    //         {
    //           path: "/admin-master/flight/apply-for",
    //           label: "Apply For",
    //           slug: "ADMIN_MASTER__FLIGHT_APPLY_FOR",
    //           element: ApplyFor,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/flight/markup-type",
    //           label: "Markup Type",
    //           slug: "ADMIN_MASTER__FLIGHT_MARKUP_TYPE",
    //           element: FlightMarkupType,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/flight/fare-type",
    //           label: "Fare Type",
    //           slug: "ADMIN_MASTER__FLIGHT_FARE_TYPE",
    //           element: FareType,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/flight/apply-on",
    //           label: "Apply On",
    //           slug: "ADMIN_MASTER__FLIGHT_APPLY_ON",
    //           element: ApplyOn,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/flight/search-type",
    //           label: "Search Type",
    //           slug: "ADMIN_MASTER__FLIGHT_SEARCH_TYPE",
    //           element: SearchType,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/flight/apply-type",
    //           label: "Apply Type",
    //           slug: "ADMIN_MASTER__FLIGHT_APPLY_TYPE",
    //           element: ApplyType,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/flight/country",
    //           label: "Country",
    //           slug: "ADMIN_MASTER__FLIGHT_ORIGIN_COUNTRY",
    //           element: OriginCountry,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         // {
    //         //   path: "/flight/destination-country",
    //         //   label: "Destination Country",
    //         //   slug: "ADMIN_MASTER__FLIGHT_DESTINATION_COUNTRY",
    //         //   element: DestinationCountry,
    //         //   icon: SquareMenu,
    //         //   rolesAllowed: [ROLES.ADMIN],
    //         // },
    //         {
    //           path: "/admin-master/flight/Suppliers",
    //           label: "Suppliers",
    //           slug: "ADMIN_MASTER__FLIGHT_SUPPLIERS",
    //           element: Suppliers,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/flight/Airlines",
    //           label: "Airlines",
    //           slug: "ADMIN_MASTER__FLIGHT_AIRLINES",
    //           element: Airlines,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/flight/Markup-fee",
    //           label: "Markup Fee",
    //           slug: "ADMIN_MASTER__FLIGHT_MARKUP_FEE",
    //           element: MarkupFee,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //       ],
    //     },
    //     {
    //       path: "/admin-master/hotel",
    //       label: "Hotel",
    //       slug: "",
    //       element: null,
    //       icon: MdHotel,
    //       rolesAllowed: [ROLES.ADMIN],
    //       isSubmenu: true,
    //       submenu: [
    //         {
    //           path: "/admin-master/hotel/supplier",
    //           label: "Supplier",
    //           slug: "ADMIN_MASTER__HOTEL_SUPPLIERS",
    //           element: HotelSuppliers,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //         {
    //           path: "/admin-master/hotel/category",
    //           label: "Hotel Category",
    //           slug: "ADMIN_MASTER__HOTEL_CATEGORY",
    //           element: HotelCategory,
    //           icon: SquareMenu,
    //           rolesAllowed: [ROLES.ADMIN],
    //         },
    //       ],
    //     },
    //     // {
    //     //   path: "/admin-master/bus-supplier",
    //     //   label: "Bus Supplier",
    //     //   slug: "ADMIN_MASTER__BUS_SUPPLIERS",
    //     //   element: BusSuppliers,
    //     //   icon: BsTruckFront,
    //     //   rolesAllowed: [ROLES.ADMIN],
    //     // },
    //     // {
    //     // {
    //     //   path: "/admin-master/hold-booking-config",
    //     //   label: "Hold Booking Config",
    //     //   slug: "home",
    //     //   element: HoldBookingConf,
    //     //   icon: SquareMenu,
    //     //   rolesAllowed: [ROLES.ADMIN],
    //     // },
    //     // {
    //     //   path: "/admin-master/manage-hold-booking",
    //     //   label: "Manage Hold Booking",
    //     //   slug: "home",
    //     //   element: ManageHoldBooking,
    //     //   icon: SquareMenu,
    //     //   rolesAllowed: [ROLES.ADMIN],
    //     // },
    //     // {
    //     //   path: "/admin-master/enable-coupon-feature",
    //     //   label: "Enable Coupon Feature",
    //     //   slug: "home",
    //     //   element: EnableCouponFeature,
    //     //   icon: SquareMenu,
    //     //   rolesAllowed: [ROLES.ADMIN],
    //     // },
    //   ],
    // },
    {
      path: "/settings",
      label: "Settings",
      slug: "",
      element: null,
      icon: MonitorCog,
      rolesAllowed: [ROLES.ADMIN],
      isSubmenu: true,
      submenu: [
        {
          path: "settings/auto-ticketing",
          label: "Auto Ticketing",
          slug: "SETTINGS__ENABLE_AUTO_TICKET",
          element: AutoTicketing,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
      ],
    },
    {
      path: "/group-settings",
      label: "Group Settings",
      slug: "",
      element: null,
      icon: Users,
      rolesAllowed: [ROLES.ADMIN],
      isSubmenu: true,
      submenu: [
        {
          path: "/group-settings/manage-group-b2b",
          label: "Manage Group B2B",
          slug: "GROUP_SETTINGS__MANAGE_GROUP_B2B",
          element: ManageGroupB2B,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        // {
        //   path: "/group-settings/group-settings-b2b",
        //   label: "Group Setting B2B",
        //   slug: "GROUP_SETTINGS__GROUP_SETTINGS_B2B",
        //   element: GroupSettingsB2B,
        //   icon: SquareMenu,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        {
          path: "/affiliate/affiliates-list",
          label: "Affiliates",
          slug: "ADMIN__VIEW_AFFILIATES",
          element: Affiliates,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/affiliate/manage-affiliates",
          label: "Manage Affiliates",
          slug: "ADMIN__MANAGE_AFFILIATES",
          element: ManageAffiliates,
          icon: null,
          rolesAllowed: [ROLES.ADMIN],
        },
      ],
    },
    {
      path: "/markup_and_commission",
      label: "Markup & Commission",
      slug: "",
      element: null,
      icon: ReceiptText,
      rolesAllowed: [ROLES.ADMIN],
      isSubmenu: true,
      submenu: [
        {
          path: "/admin-transactions/markup_and_commission/markup/b2c",
          label: "Markup B2C",
          slug: "ADMIN_TRANSACTIONS__MARKUP_B2C",
          element: MarkupB2C,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        // {
        //   path: "/markup_and_commission/discount-b2c",
        //   label: "Discount B2C",
        //   slug: "ADMIN_TRANSACTIONS__VIEW_DISCOUNT_B2C",
        //   element: Discount_B2C,
        //   icon: SquareMenu,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        {
          path: "/admin-transactions/markup_and_commission/markup/b2c/:service/:userChargeType",
          label: "Admin Transaction",
          slug: "ADMIN_TRANSACTIONS__MARKUP_B2C_CREATE",
          element: ManageMarkupB2C,
          icon: undefined,
          rolesAllowed: [ROLES.ADMIN],
        },
        // {
        //   path: "/admin-transaction/create-markup-b2c",
        //   label: "Admin Transaction",
        //   slug: "ADMIN_TRANSACTIONS__MARKUP_B2C_CREATE",
        //   element: CreateMarkup_B2C,
        //   icon: undefined,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        {
          path: "/admin-transaction/edit-markup-b2c",
          label: "Admin Transaction",
          slug: "ADMIN_TRANSACTIONS__MARKUP_B2C_EDIT",
          element: CreateMarkup_B2C,
          icon: undefined,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/markup_and_commission/create-discount-b2c",
          label: "Admin Transaction",
          slug: "ADMIN_TRANSACTIONS__CREATE_DISCOUNT_B2C",
          element: CreateDiscount_B2C,
          icon: undefined,
          rolesAllowed: [ROLES.ADMIN],
        },

        //  Markup and Commission B2B
        {
          path: "/admin-transactions/markup_and_commission/markup/b2b",
          label: "Markup B2B",
          slug: "ADMIN_TRANSACTIONS__MARKUP_B2B",
          element: MarkupB2B,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin-transactions/markup_and_commission/markup/b2b/:service/:userChargeType",
          label: "Markup B2B",
          slug: "ADMIN_TRANSACTIONS__MARKUP_B2B_CREATE",
          element: ManageMarkupB2B,
          icon: undefined,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/group-settings/view-commission-b2b",
          label: "Commission B2B",
          slug: "ADMIN_TRANSACTIONS__COMMISSION_B2B",
          element: CommissionB2B,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/group-settings/create-commission-b2b",
          label: "Commission B2B",
          slug: "ADMIN_TRANSACTIONS__COMMISSION_B2B_EDIT",
          element: CreateCommissionB2B,
          icon: undefined,
          rolesAllowed: [ROLES.ADMIN],
        },
      ],
    },
    {
      path: "/taxes-and-charges",
      label: "Taxes & Charges",
      slug: "",
      element: null,
      icon: SquarePercent,
      rolesAllowed: [ROLES.ADMIN],
      isSubmenu: true,
      submenu: [
        {
          path: "/taxes-and-charges/manage-charge-types",
          label: "Manage Charge Types",
          slug: "TAXES_CHARGES__MANAGE_CHARGE_TYPES",
          element: ManageChargeTypes,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/taxes-and-charges/manage-sub-charge-types",
          label: "Manage Sub-Charge Types",
          slug: "TAXES_CHARGES__MANAGE_SUB_CHARGE_TYPES",
          element: ManageSubChargeTypes,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/taxes-and-charges/my-charge",
          label: "My Charges",
          slug: "TAXES_CHARGES__MY_CHARGES",
          element: MyCharges,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/taxes-and-charges/other-charge",
          label: "Other Charges",
          slug: "TAXES_CHARGES__OTHER_CHARGES",
          element: OtherCharges,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
      ],
    },
    {
      path: "/affiliate",
      label: "Accounts",
      slug: "",
      element: null,
      icon: Landmark,
      rolesAllowed: [ROLES.ADMIN],
      isSubmenu: true,
      submenu: [
        {
          path: "/admin/accounts",
          label: "Account",
          slug: "ADMIN_ACCOUNT__PROFILE",
          element: AdminAccount,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin/accounts/create",
          label: "Account",
          slug: "ADMIN_ACCOUNT__PROFILE_EDIT",
          element: AddNewAccount,
          icon: null,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/admin/approve-payment",
          label: "Approve Payment",
          slug: "ADMIN_ACCOUNT__AFFILIATE_PAYMENT_REQUEST",
          element: AffiliatePaymentRequest,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        // {
        //   path: "/affiliate/accounts/create",
        //   label: "",
        //   slug: "ADMIN_AFFILIATE_ACCOUNT__PAYMENT_REQUEST_EDIT",
        //   element: CreateNewPaymentRequest,
        //   icon: null,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        {
          path: "/affiliate/accounts",
          label: "Payment Requests",
          slug: "AFFILIATE_ACCOUNT__PAYMENT_REQUEST",
          element: PaymentRequest,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/affiliate/accounts/create",
          label: "",
          slug: "AFFILIATE_ACCOUNT__PAYMENT_REQUEST_EDIT",
          element: CreateNewPaymentRequest,
          icon: null,
          rolesAllowed: [ROLES.ADMIN],
        },
      ],
    },
    {
      path: "/online-booking",
      label: "Online Booking",
      slug: "",
      element: null,
      icon: BriefcaseBusiness,
      rolesAllowed: [ROLES.ADMIN],
      isSubmenu: true,
      submenu: [
        {
          path: "/online-booking/success",
          label: "Success",
          slug: "ONLINE_BOOKING__SUCCESS",
          element: BookingList,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/online-booking/pending",
          label: "In Progress",
          slug: "ONLINE_BOOKING__HOLD_BOOKING_DETAILS",
          element: BookingList,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/online-booking/ticketing_pending",
          label: "Ticket Pending",
          slug: "ONLINE_BOOKING__TICKETING_PENDING",
          element: BookingList,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/online-booking/failed",
          label: "Failed",
          slug: "ONLINE_BOOKING__FAILED",
          element: BookingList,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/online-booking/cancelled",
          label: "Cancelled",
          slug: "ONLINE_BOOKING__CANCELLED",
          element: BookingList,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        // {
        //   path: "/online-booking/Flight",
        //   label: "Master Flight Bookings",
        //   slug: "ONLINE_BOOKING__FLIGHT_MASTER_BOOKING",
        //   element: OnlineFlightBookingList,
        //   icon: PiAirplaneInFlightLight,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        {
          path: "/online-booking/flight/details/:uuid",
          label: "Online Booking",
          slug: "ONLINE_BOOKING__FLIGHT_DETAILS",
          element: FlightBookingDetails1G,
          icon: undefined,
          rolesAllowed: [ROLES.ADMIN],
        },
        // {
        //   path: "/online-booking/Hotels",
        //   label: "Master Hotels bookings",
        //   slug: "ONLINE_BOOKING__HOTEL_MASTER_BOOKING",
        //   element: OnlineHotelsBooking,
        //   icon: MdOutlineHotel,
        //   rolesAllowed: [ROLES.ADMIN],
        // },
        {
          path: "/online-booking/Hotels/HB/:id",
          label: "Hotels bookings",
          slug: "ONLINE_BOOKING__HOTEL_DETAILS",
          element: HotelBookingDetailsHB,
          icon: undefined,
          rolesAllowed: [ROLES.ADMIN],
        },
      ],
    },
    {
      path: "/online-booking/refundable",
      label: "Refundable Booking",
      slug: "",
      element: null,
      icon: TicketSlash,
      rolesAllowed: [ROLES.ADMIN],
      isSubmenu: true,
      submenu: [
        {
          path: "/online-booking/to_be_refunded",
          label: "To be Refunded",
          slug: "ONLINE_BOOKING__REFUNDED",
          element: BookingList,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
        {
          path: "/online-booking/refunded",
          label: "Refunded",
          slug: "ONLINE_BOOKING__REFUNDED",
          element: BookingList,
          icon: SquareMenu,
          rolesAllowed: [ROLES.ADMIN],
        },
      ],
    },
    {
      path: "/profile/details",
      label: "Profile",
      slug: "home",
      element: Profile,
      icon: UserCircle,
      rolesAllowed: [ROLES.ADMIN, ROLES.AFFILIATE],
    },
  ],
};

export default ROUTES;
